/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowRepeat
 * @description
 * The wcRowRepeat directive is responsible for the row repeat operation on a datatable
 */



angular.module('WcResponsiveTableModule').directive('wcRowRepeat', ['$compile', function($compile) {
	return {
        require: ['wcRowRepeat', '^wcResponsiveTable'],
        controllerAs: 'rowRepeatController',
		controller: ['$scope', '$element', '$attrs', 'WcTranslateConfiguratorService', function($scope, $element, $attrs, WcTranslateConfiguratorService) {

            WcTranslateConfiguratorService.loadPartAndRefresh('WC-dataTable');

			var responsiveTableController = $element.parent().controller('wcResponsiveTable');
			var numberOfCols = responsiveTableController.numberOfCols;
			var noRecordRow = $('<tr><td class="text-center" colspan='+numberOfCols+' >{{"noRecordFound" | translate}}</td></tr>');

			this.collection = responsiveTableController.WcTableCollectionService.getCollection;
			this.rowKey = responsiveTableController.WcTableCollectionService.getRowKey();

			this.parentElement = $element.parent();
			this.elements = [];
			this.insertRows = function(pageStart, pageEnd) {
				var elementsLength = this.elements.length;

				var ngModel = responsiveTableController.ngModel;
				var collection = responsiveTableController.WcTableCollectionService.getCollection();

				if(elementsLength > 0) {
					for (var i = 0; i < elementsLength; i++) {
						this.elements[i].el.remove();
						this.elements[i].scope.$destroy();
					}
					this.elements = [];
				}

				//TODO make setCollection update pagination instead
				if(collection.length < pageEnd) {
					pageEnd = collection.length;
				}

				for (var index = pageStart; index < pageEnd; index++) {
					var childScope = $scope.$new(false, responsiveTableController.WcTableScopeService.getTableScope());
					childScope.row = collection[index];
					childScope.rowKey = childScope.row[this.rowKey];
					childScope.index = index;

					if(ngModel && ngModel.length > 0) {
						// var alreadySelected = ngModel.reduce(function(prev, next) {
						// 	return next === childScope.rowKey ? next : prev;
						// }, null);
						var alreadySelected = _.find(ngModel, function(value) { return value === childScope.rowKey; });

						if (alreadySelected) {
							childScope.isSelected = true;
						}
					}

					var newRow = $('<tr></tr>');
					_.forEach($attrs.$attr, function(value, key) {
						if (key != 'wcRowRepeat') {
							newRow.attr(value, $attrs[key]);
						}
					});
					newRow.append(responsiveTableController.dataRowChildren.clone());

					var block = {};
					block.el = newRow;
					block.scope = childScope;
					this.elements.push(block);

					$(noRecordRow).remove();
					this.parentElement.append(newRow);
					$compile(newRow)(childScope);
				}

                var mappedCollection = _.map(responsiveTableController.columnsToHide, function(value, key) { return {key: key, value: value}; });
                var selectedItems = _.filter(mappedCollection, {value: false});
                var hiddenColumns = _.map(selectedItems, function(value) { return value.key; });
				for(var i=0; i < hiddenColumns.length; i++){
                    $('#'+responsiveTableController.id+'.column-toggle .wc-table-column-'+hiddenColumns[i]).hide();
				}

				if(collection.length<1 && this.parentElement[0].children.length<1) {

					this.parentElement.append($compile(noRecordRow)($scope));
				}

				$element.remove();
			};

		}],
		link: function(scope, element, attr, controllers) {
        	//jshint unused:true
			var rowRepeatController = controllers[0];
            var responsiveTableController = controllers[1];

			scope.$on('table.render.start', function() {
				var paginationDefaults = responsiveTableController.WcTablePaginationService.getPaginationDefaults();
				rowRepeatController.insertRows(paginationDefaults.pageStart, paginationDefaults.pageEnd);
				responsiveTableController.WcTableScopeService.getTableScope().tableRendered();
			});



		}
	};
}]);
